import React from 'react';

const CertificationSelector = ({ 
  certifications, 
  selectedCertification, 
  onCertificationSelect 
}) => {
  const handleDropdownChange = (event) => {
    const selectedId = event.target.value;
    if (selectedId) {
      const selectedCert = certifications.find(cert => cert.id === selectedId);
      if (selectedCert) {
        onCertificationSelect(selectedCert);
      }
    }
  };

  return (
    <div className="certification-selector">
      <div className="certification-dropdown-row">
        <h2><i className="fas fa-graduation-cap"></i> Select Certification:</h2>
        <select
          className="certification-dropdown"
          value={selectedCertification?.id || ''}
          onChange={handleDropdownChange}
        >
          {certifications.map((cert) => (
            <option key={cert.id} value={cert.id}>
              {cert.name}
            </option>
          ))}
        </select>
      </div>
      {/* <div className="certification-selection-display">
        {selectedCertification && (
          <div className="selected-cert-indicator">
            <i className={selectedCertification.icon} style={{ color: selectedCertification.color }}></i>
            <span className="selected-cert-name">{selectedCertification.name}</span>
          </div>
        )}
      </div> */}
    </div>
  );
};

export default CertificationSelector;
